import Navbar from "../components/sections/Navbar";
import PageHeader from "../components/sections/PageHeader";
import GradientHeader from "../components/ui/GradientHeader";
import BlogLayout from "../components/layout/BlogLayout";
import BlogSidebar from "../components/sections/BlogSidebar";
import BlogContent from "../components/sections/BlogContent";
import BlogRight from "../components/sections/BlogRight";
import Divider from  "../components/ui/Divider"
import Button from "../components/ui/Button";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

function Blog() {
    const { authorizedFetch, tokens } = useAuth();
    const [isSending, setIsSending] = useState(false);
    const [sendStatus, setSendStatus] = useState("");

    const handleSendTestEmail = async () => {
        if (!tokens?.access || isSending) {
            return;
        }
        setIsSending(true);
        setSendStatus("");
        try {
            const response = await authorizedFetch("/api/test_email/", {
                method: "POST",
            });
            if (!response.ok) {
                throw new Error(`Request failed (${response.status})`);
            }
            setSendStatus("Testmail verzonden.");
        } catch (error) {
            setSendStatus("Testmail versturen mislukt.");
            // eslint-disable-next-line no-console
            console.error("Test mail failed:", error);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div>
            {/* Navbar always at top */}
            <Navbar />
            <GradientHeader />
            <div className="container">
                <PageHeader title="Welkom in het platform van ContinuMee" />
                <div style={{ marginTop: 12 }}>
                    {sendStatus ? (
                        <span style={{ marginLeft: 12, color: "#4b5563" }}>{sendStatus}</span>
                    ) : null}
                </div>
                <Divider mt={20} />
                <BlogLayout
                    sidebar={<BlogSidebar />}
                    content={<BlogContent />}
                    right={<BlogRight />}
                />
            </div>
        </div>
    );
}

export default Blog;
